"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFilteredColumnTree = exports["default"] = exports.ColumnTreeContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Tabs = _interopRequireDefault(require("./Tabs"));
var _cccisdFormik = require("cccisd-formik");
var _FilterForm = _interopRequireWildcard(require("./FilterForm"));
var _AssignmentForm = _interopRequireDefault(require("./AssignmentForm"));
var _CheckboxInput = _interopRequireDefault(require("./CheckboxInput"));
var _TagInput = _interopRequireDefault(require("./TagInput"));
var _MetricsPicker = _interopRequireDefault(require("./MetricsPicker"));
var _Panel = _interopRequireDefault(require("../Panel"));
var _xor2 = _interopRequireDefault(require("lodash/xor"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _union2 = _interopRequireDefault(require("lodash/union"));
var _intersection2 = _interopRequireDefault(require("lodash/intersection"));
var _flatten2 = _interopRequireDefault(require("lodash/flatten"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _arrowRight = _interopRequireDefault(require("cccisd-icons/arrow-right20"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down20"));
var _checkmark = _interopRequireDefault(require("cccisd-icons/checkmark"));
var _pushpin = _interopRequireDefault(require("cccisd-icons/pushpin"));
var _metricTypes = _interopRequireDefault(require("../../Code/metricTypes.js"));
var _getColumnTree = _interopRequireDefault(require("./getColumnTree.js"));
var _immutabilityHelper = _interopRequireDefault(require("immutability-helper"));
var _reactRedux = require("react-redux");
var _admin = require("../../../selectors/admin.js");
var _mergeColumnTree = _interopRequireDefault(require("./mergeColumnTree.js"));
var _removeIdentifiableFields = _interopRequireDefault(require("./removeIdentifiableFields.js"));
var _cccisdHiddenBlock = _interopRequireDefault(require("cccisd-hidden-block"));
var _classnames = _interopRequireDefault(require("classnames"));
var _getRoleHandlesFromDeploymentList = _interopRequireDefault(require("../getRoleHandlesFromDeploymentList.js"));
var _cccisdConfirm = _interopRequireDefault(require("cccisd-confirm"));
var _style = _interopRequireDefault(require("./style.css"));
var _excluded = ["handleSubmit", "values", "errors", "submitCount", "setFieldValue"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Fortress = window.cccisd.fortress;
var showQueryToOptions = [{
  value: 'all',
  label: 'Users with and without Identifiable permission for this Quest Project'
}, {
  value: 'withIdentifiable',
  label: 'Only users with Identifiable permission for this Quest Project'
}];
var csvHeaderOptions = [{
  value: 'label',
  label: 'Variable'
}, {
  value: 'question',
  label: 'Question'
}, {
  value: 'originalLabel',
  label: 'Label'
}];
var getFilteredColumnTree = function getFilteredColumnTree(search, columnTree1) {
  var result = (0, _cloneDeep2["default"])(columnTree1);
  search = search.toLowerCase();
  function filterTree(node) {
    if (!node.label) {
      return false;
    }
    if (node.children) {
      node.children = node.children.filter(filterTree);
      return node.children.length > 0;
    }
    return node.label.toLowerCase().includes(search);
  }
  return result.filter(filterTree);
};
exports.getFilteredColumnTree = getFilteredColumnTree;
var ColumnTreeContext = /*#__PURE__*/_react["default"].createContext([]);
exports.ColumnTreeContext = ColumnTreeContext;
var validate = function validate(values) {
  var errors = {};
  var result = (0, _FilterForm.validate)(values.filter);
  if (result) {
    for (var _i = 0, _Object$entries = Object.entries(result); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];
      errors["filter.".concat(key)] = value;
    }
  }
  return errors;
};
var FormItself = function FormItself(props) {
  var values = props.values,
    errors = props.errors,
    submitCount = props.submitCount,
    setFieldValue = props.setFieldValue,
    assignmentMetrics = props.assignmentMetrics,
    loadAssignmentMetrics = props.loadAssignmentMetrics;
  var usedColumns = new Set();
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = _slicedToArray(_useState3, 2),
    search = _useState4[0],
    setSearch = _useState4[1];
  var projectFields = (0, _reactRedux.useSelector)(function (state) {
    return (0, _admin.getCurrentProjectFields)(state.assignment.admin);
  });
  var adminState = (0, _reactRedux.useSelector)(function (state) {
    return state.assignment.admin;
  });
  var availableTags = (0, _reactRedux.useSelector)(function (state) {
    return (0, _admin.getAvailableTags)(state.assignment.admin);
  });
  var project = (0, _reactRedux.useSelector)(function (state) {
    return (0, _admin.getCurrentProject)(state.assignment.admin);
  });
  var restrictionsLevel = (0, _reactRedux.useSelector)(function (state) {
    return (0, _admin.getRestrictionsLevel)(state.assignment.admin);
  });
  var columnTree = (0, _react.useMemo)(function () {
    var adjustedState = (0, _immutabilityHelper["default"])(adminState, {
      currentQuerySettings: {
        assignmentId: {
          $set: Number(values.assignmentId)
        }
      }
    });
    var deploymentList = (0, _admin.getCurrentQueryAssignmentActiveDeployments)(adjustedState);
    var roleHandles = (0, _getRoleHandlesFromDeploymentList["default"])(deploymentList.filter(function (item) {
      return values.deploymentIds === 'all' || values.deploymentIds.includes(item.deploymentId);
    }));
    var currentColumnTree = roleHandles.length === 0 ? (0, _getColumnTree["default"])({
      level: 'roles',
      projectFields: projectFields
    }) : (0, _mergeColumnTree["default"])(roleHandles.map(function (name) {
      return (0, _getColumnTree["default"])({
        level: 'roles',
        rows: name,
        projectFields: projectFields
      });
    }));

    // remove identifiable fields if the user doesn't have permissions
    if (!Fortress.hasAccess('quest.view_identifiable_data', project.groupId) && roleHandles.length > 0) {
      var identifiableFields = window.cccisd.appDefs.pawn.roles.reduce(function (list, role) {
        if (roleHandles.includes(role.handle)) {
          (role.identifiableFields || []).forEach(function (field) {
            list.add(field);
          });
        }
        return list;
      }, new Set());
      for (var _i2 = 0, _Object$values = Object.values(projectFields); _i2 < _Object$values.length; _i2++) {
        var field = _Object$values[_i2];
        if (field.isIdentifiable) {
          identifiableFields.add(field.path);
        }
      }
      return (0, _removeIdentifiableFields["default"])(currentColumnTree, identifiableFields);
    }
    return currentColumnTree;
  }, [adminState, values.assignmentId, values.deploymentIds, projectFields]);
  var filteredTree = (0, _react.useMemo)(function () {
    return getFilteredColumnTree(search, columnTree);
  }, [search, columnTree]);
  var variables = (0, _react.useMemo)(function () {
    if (!assignmentMetrics[values.assignmentId]) {
      return [];
    }
    var hasIdenifiablePermission = Fortress.hasAccess('quest.view_identifiable_data', project.groupId);
    return assignmentMetrics[values.assignmentId].filter(function (item) {
      return hasIdenifiablePermission || !item.isIdentifying;
    }).sort(function (a, b) {
      return a.reportHeader.localeCompare(b.reportHeader);
    });
  }, [assignmentMetrics, values.assignmentId]);
  (0, _react.useEffect)(function () {
    loadAssignmentMetrics(values.assignmentId);
  }, [values.assignmentId]);
  var variablesOptions = (0, _react.useMemo)(function () {
    var handleSet = new Set(values.surveyHandles === 'all' ? [] : values.surveyHandles);
    var metricsByType = variables.filter(function (variable) {
      return variable.type === 'formula' || values.surveyHandles === 'all' || variable.surveyHandles.some(function (handle) {
        return handleSet.has(handle);
      });
    }).reduce(function (obj, item) {
      var _item$content;
      obj[item.type] = obj[item.type] || [];
      obj[item.type].push({
        id: item.reportHeader,
        label: item.label,
        question: (_item$content = item.content) === null || _item$content === void 0 ? void 0 : _item$content.title
      });
      return obj;
    }, {});
    return _metricTypes["default"].filter(function (type) {
      return type.value !== 'correct' || restrictionsLevel === 'unlimited';
    }).map(function (type) {
      return _objectSpread(_objectSpread({}, type), {}, {
        list: metricsByType[type.value] || []
      });
    });
  }, [variables, values.surveyHandles, restrictionsLevel]);

  // set metrics value
  (0, _react.useEffect)(function () {
    var newList = _union2["default"].apply(void 0, [values.metrics.list].concat(_toConsumableArray(variablesOptions.filter(function (option) {
      return values.metrics.types.includes(option.value);
    }).map(function (option) {
      return option.list.map(function (item) {
        return item.id;
      });
    }))));
    setFieldValue('metrics', _objectSpread(_objectSpread({}, values.metrics), {}, {
      list: newList
    }));
    setFieldValue('variablesOptions', variablesOptions);
  }, [variablesOptions]);
  var toggleExpanded = function toggleExpanded(value) {
    return setExpanded((0, _xor2["default"])(expanded, [value]));
  };
  var getTabs = function getTabs() {
    var traverse = function traverse(node, field, form) {
      if (node.children) {
        var isExpanded = expanded.includes(node.id) || !!search;
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].header,
          onClick: function onClick() {
            return toggleExpanded(node.id);
          }
        }, isExpanded ? /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], {
          spaceRight: true
        }) : /*#__PURE__*/_react["default"].createElement(_arrowRight["default"], {
          spaceRight: true
        }), node.label), isExpanded && /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].level
        }, node.children.map(function (child) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: child.id
          }, traverse(child, field, form));
        })));
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "checkbox",
        style: {
          margin: 0,
          display: 'flex',
          alignItems: 'center'
        }
      }, /*#__PURE__*/_react["default"].createElement("label", null, usedColumns.has(node.id) && /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].used
      }, /*#__PURE__*/_react["default"].createElement(_checkmark["default"], null)), /*#__PURE__*/_react["default"].createElement("input", {
        type: "checkbox",
        value: node.id,
        checked: node.id in field.value,
        onChange: function onChange(e) {
          form.setFieldValue(field.name, e.target.checked ? _objectSpread(_objectSpread({}, field.value), {}, _defineProperty({}, node.id, node)) : (0, _omit2["default"])(field.value, node.id));
        },
        disabled: usedColumns.has(node.id),
        style: usedColumns.has(node.id) ? {
          visibility: 'hidden'
        } : {}
      }), node.label), node.id in field.value && /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: (0, _classnames["default"])('btn btn-default btn-xs', _style["default"].button, {
          'btn-primary active': field.value[node.id].sticky
        }),
        onClick: function onClick(e) {
          e && e.preventDefault();
          var nodeValue = field.value[node.id];
          form.setFieldValue(field.name, _objectSpread(_objectSpread({}, field.value), {}, _defineProperty({}, node.id, _objectSpread(_objectSpread({}, nodeValue), {}, {
            sticky: !nodeValue.sticky
          }))));
        }
      }, /*#__PURE__*/_react["default"].createElement(_pushpin["default"], null)));
    };
    return [{
      name: 'assignment',
      title: 'Quest',
      content: /*#__PURE__*/_react["default"].createElement(_AssignmentForm["default"], {
        values: values,
        setFieldValue: setFieldValue
      })
    }, {
      name: 'columns',
      title: 'Columns',
      content: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Panel["default"], {
        header: "Respondent"
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/_react["default"].createElement("input", {
        name: "search",
        className: "form-control",
        placeholder: "search",
        style: {
          width: '10em'
        },
        autoFocus: true,
        autoComplete: "off",
        value: search,
        onChange: function onChange(e) {
          return setSearch(e.target.value);
        }
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].content
      }, filteredTree.length === 0 ? 'No column found' : /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "columns",
        render: function render(_ref) {
          var field = _ref.field,
            form = _ref.form;
          return filteredTree.map(function (item) {
            return /*#__PURE__*/_react["default"].createElement("div", {
              key: item.id
            }, traverse(item, field, form));
          });
        }
      })))), /*#__PURE__*/_react["default"].createElement(_Panel["default"], {
        header: "Deployment"
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "waveName",
        label: "Wave name",
        component: _CheckboxInput["default"]
      }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "waveTimepoint",
        label: "Wave timepoint",
        component: _CheckboxInput["default"]
      }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "surveyLanguage",
        label: "Language",
        component: _CheckboxInput["default"]
      }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "surveyList",
        label: "Form",
        tooltip: /*#__PURE__*/_react["default"].createElement("div", {
          className: "text-center"
        }, "Form shows which form (a custom set of surveys) was selected or assigned to this set of responses. This is always \u2018default\u2019 unless your Quest is configured to use multiple forms. This is unusual."),
        component: _CheckboxInput["default"]
      }))), /*#__PURE__*/_react["default"].createElement(_Panel["default"], {
        header: "Metrics"
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "metrics",
        component: _MetricsPicker["default"],
        options: variablesOptions
      }))))
    }, {
      name: 'filter',
      title: 'Filter',
      content: /*#__PURE__*/_react["default"].createElement(ColumnTreeContext.Provider, {
        value: columnTree
      }, /*#__PURE__*/_react["default"].createElement(_FilterForm["default"], {
        values: values.filter,
        addFilter: function addFilter() {
          setFieldValue('filter', {
            aggregation: 'all',
            conditions: [{
              id: 1,
              column: null,
              operator: ''
            }]
          });
        },
        removeFilter: function removeFilter() {
          setFieldValue('filter', null);
        }
      })),
      hasError: submitCount > 0 && Object.keys(errors).some(function (key) {
        return /^filter\./.test(key);
      })
    }, {
      name: 'settings',
      title: 'Settings',
      content: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "codedValues",
        label: "Coded values",
        component: _CheckboxInput["default"],
        tooltip: "If unchecked, displays the raw value for the collected metrics. If checked, displays the coded value."
      }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "showQueryTo",
        label: "Show query to:",
        render: function render(_ref2) {
          var field = _ref2.field,
            form = _ref2.form;
          var value = field.value || 'all';
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: "form-group",
            style: {
              marginTop: '1em'
            }
          }, /*#__PURE__*/_react["default"].createElement("label", null, "Show Query to:"), showQueryToOptions.map(function (option) {
            return /*#__PURE__*/_react["default"].createElement("div", {
              key: option.value,
              className: "radio",
              style: {
                margin: 0
              }
            }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", {
              type: "radio",
              name: field.name,
              value: option.value,
              checked: value === option.value,
              onChange: function onChange() {
                return form.setFieldValue(field.name, option.value);
              }
            }), option.label));
          }), /*#__PURE__*/_react["default"].createElement("div", {
            className: "alert alert-info",
            style: {
              marginTop: '0.8em',
              padding: '0.5em'
            }
          }, /*#__PURE__*/_react["default"].createElement("b", null, "Note:"), " any fields that are identifiable will be hidden from users that have access to this query but not identifiable permission."));
        }
      }), /*#__PURE__*/_react["default"].createElement(_cccisdHiddenBlock["default"], {
        title: "Download CSV - header options"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "csvHeaders",
        label: "CSV headers",
        render: function render(_ref3) {
          var field = _ref3.field,
            form = _ref3.form;
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: "form-group"
          }, csvHeaderOptions.map(function (item) {
            return /*#__PURE__*/_react["default"].createElement("div", {
              key: item.value,
              className: "checkbox",
              style: {
                margin: '2px 0'
              }
            }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", {
              type: "checkbox",
              value: item.value,
              checked: (field.value || ['label']).includes(item.value),
              onChange: function onChange() {
                var list = (0, _xor2["default"])(field.value || ['label'], [item.value]);
                // use order of the original list
                var newValue = csvHeaderOptions.filter(function (option) {
                  return list.includes(option.value);
                }).map(function (option) {
                  return option.value;
                });
                form.setFieldValue(field.name, newValue);
              }
            }), ' ', item.label));
          }));
        }
      })), restrictionsLevel === 'unlimited' && /*#__PURE__*/_react["default"].createElement(_cccisdHiddenBlock["default"], {
        title: "Advanced settings"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "tags",
        label: "Tags",
        component: _TagInput["default"],
        availableTags: availableTags
      })))
    }];
  };
  return /*#__PURE__*/_react["default"].createElement(_Tabs["default"], {
    tabList: getTabs()
  });
};
FormItself.propTypes = {
  values: _propTypes["default"].object,
  setFieldValue: _propTypes["default"].func,
  submitCount: _propTypes["default"].number,
  errors: _propTypes["default"].object,
  assignmentMetrics: _propTypes["default"].object,
  loadAssignmentMetrics: _propTypes["default"].func
};
var CustomQueryForm = function CustomQueryForm(props) {
  var project = (0, _reactRedux.useSelector)(function (state) {
    return (0, _admin.getCurrentProject)(state.assignment.admin);
  });
  var deleteQuery = function deleteQuery() {
    (0, _cccisdConfirm["default"])({
      message: 'Are you sure?',
      description: 'You are about to delete a query'
    }).then(function () {
      props.onDelete();
    });
  };
  return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
    initialValues: props.initialValues,
    onSubmit: function onSubmit(values) {
      // TODO: include metrics only for selected surveys
      var includingList = (0, _flatten2["default"])(values.variablesOptions.filter(function (option) {
        return !values.metrics.types.includes(option.value);
      }).map(function (option) {
        return option.list.map(function (item) {
          return item.id;
        });
      }));
      var result = _objectSpread(_objectSpread({}, (0, _omit2["default"])(values, 'variablesOptions')), {}, {
        assignmentId: Number(values.assignmentId),
        metrics: _objectSpread(_objectSpread({}, values.metrics), {}, {
          list: (0, _intersection2["default"])(values.metrics.list, includingList)
        })
      });
      props.onSubmit(result);
      props.closeModal();
    },
    validate: validate,
    render: function render(_ref4) {
      var handleSubmit = _ref4.handleSubmit,
        values = _ref4.values,
        errors = _ref4.errors,
        submitCount = _ref4.submitCount,
        setFieldValue = _ref4.setFieldValue,
        rest = _objectWithoutProperties(_ref4, _excluded);
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement(FormItself, {
        values: values,
        setFieldValue: setFieldValue,
        errors: errors,
        submitCount: submitCount,
        assignmentMetrics: props.assignmentMetrics,
        loadAssignmentMetrics: props.loadAssignmentMetrics
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].buttonArea
      }, /*#__PURE__*/_react["default"].createElement("button", {
        className: "btn btn-primary",
        type: "submit",
        onClick: handleSubmit
      }, "Submit"), props.onDelete && Fortress.hasAccess('quest.tables_edit', project.groupId) && /*#__PURE__*/_react["default"].createElement("button", {
        className: "btn btn-danger",
        type: "button",
        onClick: deleteQuery
      }, "Delete query")));
    }
  });
};
CustomQueryForm.propTypes = {
  initialValues: _propTypes["default"].object,
  closeModal: _propTypes["default"].func,
  onSubmit: _propTypes["default"].func,
  onDelete: _propTypes["default"].func,
  assignmentMetrics: _propTypes["default"].object,
  loadAssignmentMetrics: _propTypes["default"].func
};
CustomQueryForm.defaultProps = {};
var _default = CustomQueryForm;
exports["default"] = _default;